import { computed, ref } from 'vue'
import { games, isGameVisible } from '@/data/games'

const STORAGE_KEY = 'lgw-recent-game-ids'
const MAX_RECENT = 20

/** 变更版本号：同页内下注后大厅列表能立刻刷新 */
const recentVersion = ref(0)

function readIds () {
  try {
    const raw = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]')
    if (!Array.isArray(raw)) return []
    return raw.map(Number).filter((n) => n > 0)
  } catch {
    return []
  }
}

function writeIds (ids) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ids.slice(0, MAX_RECENT)))
  } catch {
    /* ignore quota / private mode */
  }
  recentVersion.value += 1
}

/**
 * 下注成功后调用：将该彩种顶到「最近游玩」最前
 * @param {number|string} gameId
 */
export function touchRecentGame (gameId) {
  const id = Number(gameId)
  if (!(id > 0)) return
  const next = [id, ...readIds().filter((x) => x !== id)].slice(0, MAX_RECENT)
  writeIds(next)
}

export function clearRecentGames () {
  writeIds([])
}

export function useRecentGames () {
  const recentIds = computed(() => {
    // 依赖 version，确保 touch 后 computed 重算
    void recentVersion.value
    return readIds()
  })

  const recentGames = computed(() =>
    recentIds.value
      .map((id) => games.value.find((g) => Number(g.id) === Number(id)))
      .filter((g) => g && isGameVisible(g))
  )

  return {
    recentIds,
    recentGames,
    touchRecentGame,
    clearRecentGames,
    recentVersion
  }
}
